export const  devGetTokenByUserType = (userType) => {
    switch (userType) {
      case 'ente':
        return 'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJDbjE2ODZIenkzdUpxWGtHcUF6c1hhS0dGRTFsRHhDcFRsOTB3UklFc1FFIn0.eyJleHAiOjE2OTQ1OTgzNjcsImlhdCI6MTY5NDU5ODA2NywiYXV0aF90aW1lIjoxNjk0NTk4MDY2LCJqdGkiOiI2YWEzMTEwNy01YzRhLTQ2MGEtOTczYi1jM2QxMDJmMjgyOTYiLCJpc3MiOiJodHRwczovL3RyaWFsLmF1dGgucmVnaW9uZS50b3NjYW5hLml0L2F1dGgtdHJpYWwvcmVhbG1zL3J0IiwiYXVkIjoibmlkaWdyYXRpcy1ycyIsInN1YiI6IjIxNWM0NTZlLTQzZmMtNDlmMy1hZTM4LTlkZmNkYmQ1ZjBjZiIsInR5cCI6IkJlYXJlciIsImF6cCI6InJfdG9zY2FuX19uaWRpZ3JhdGlzIiwic2Vzc2lvbl9zdGF0ZSI6ImNiNDM3YWY4LWEwYmEtNGZmNy1iY2VjLWMyMmY2Y2YxOGQ4YSIsImFjciI6IjEiLCJzY29wZSI6Im5pZGlncmF0aXMtcnMvYXVkaWVuY2UgZGVmYXVsdCBwcm9maWxlIiwic2lkIjoiY2I0MzdhZjgtYTBiYS00ZmY3LWJjZWMtYzIyZjZjZjE4ZDhhIiwiYXV0aF90eXBlIjoic3BpZC1kZW1vLWlkcCIsImF1dGhfbGV2ZWwiOiIyIiwicHJlZmVycmVkX3VzZXJuYW1lIjoidGluaXQtbW56bHNuOTllMDVmMjA1aiJ9.VY1i6Kk1jFP8pEdlpdYXv8gyWPF8OLXODCfYZUm3tRwaSfMUnt7nAvwFPkeLDWEZNVwZ-8X_ykD-ZIqo6LvNUGVmClsshi88Uto2bfBXA3OHSoVRXqmapQH_80BYpWnXWmXDVbot9wQsl4QuIOSd9EtzfkxieUh_g8yUxu-V8qTAWnX4xl2K4JYvqZeFNYin74cZPuI-VH-iMvExb-4Q1zEqwNmSBuLNdAOVeR_tYHnz07_Tb3TX5CdwOryNwNSZps174OcumDXqyApJciw8Q9oyAOJv_kySE5p-8ksFZ20zDIARZtiD-blP20y_XahdUzTZOofm8VhFF8O7-mezrA';
      case 'regione':
        return 'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJDbjE2ODZIenkzdUpxWGtHcUF6c1hhS0dGRTFsRHhDcFRsOTB3UklFc1FFIn0.eyJleHAiOjE2OTQ2OTQ2MzksImlhdCI6MTY5NDY5NDMzOSwiYXV0aF90aW1lIjoxNjk0Njk0MzM5LCJqdGkiOiJiNTMxZDU0NC1mMjQ4LTRiMzctYmUxMi03MmZiMmU0MGE2Y2IiLCJpc3MiOiJodHRwczovL3RyaWFsLmF1dGgucmVnaW9uZS50b3NjYW5hLml0L2F1dGgtdHJpYWwvcmVhbG1zL3J0IiwiYXVkIjoibmlkaWdyYXRpcy1ycyIsInN1YiI6ImRjZmNjMWFmLTNkMDctNDhkOC05ZGQyLWEzZTEzMjM5YzBkMyIsInR5cCI6IkJlYXJlciIsImF6cCI6InJfdG9zY2FuX19uaWRpZ3JhdGlzIiwic2Vzc2lvbl9zdGF0ZSI6IjA0MDJmZTVmLWRkMjMtNDNiOS1hZjA1LTk1NDZlMzlmYWE5NyIsImFjciI6IjEiLCJzY29wZSI6ImVtYWlsIG5pZGlncmF0aXMtcnMvYXVkaWVuY2UgZGVmYXVsdCBwcm9maWxlIiwic2lkIjoiMDQwMmZlNWYtZGQyMy00M2I5LWFmMDUtOTU0NmUzOWZhYTk3IiwiYXV0aF90eXBlIjoic3BpZC1kZW1vLWlkcCIsImF1dGhfbGV2ZWwiOiIyIiwicHJlZmVycmVkX3VzZXJuYW1lIjoidGluaXQtZnJtdHRyNzZtMDZiNzE1ZSJ9.fy_-RptSHE9aw253YufzF2xF4_BLmnG9ycpOepgio_Le3hx_-Oco8FT9P9AfsK7fWehUcyiM8cj_854CtzAfJk5Aj8AxEff2MmBagYamA4WQ-52RA5MArAA6pL_XpGpDBzc15-8kqWhXYHMQhZFD82qQPEe2fQkPvVpdFwgDZWwyGYEM94zMmUPQprplyG2gxJTUO7TgUzbA7t8_M7mtFKiqCDNQw6ph00TVDC5-Mg-A1SfXn9k-XFImJ5qUhr9_qPG6cwDklnvwhnhiTIcMM25LNmlI4uD_WCcW5qP3ybqxxcVVtFWt5i0FEv6FLpw5oPzKPu_KBf7aGD_Wk6SyLA';
      case 'admin':
        return 'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJDbjE2ODZIenkzdUpxWGtHcUF6c1hhS0dGRTFsRHhDcFRsOTB3UklFc1FFIn0.eyJleHAiOjE2OTQ2MDY4OTgsImlhdCI6MTY5NDYwNjU5OCwiYXV0aF90aW1lIjoxNjk0NjA2NTk4LCJqdGkiOiI3NmJhYTdiZi03YzFlLTQ4MTItYTk1ZS1kNjNkNTA0ZGQxMmEiLCJpc3MiOiJodHRwczovL3RyaWFsLmF1dGgucmVnaW9uZS50b3NjYW5hLml0L2F1dGgtdHJpYWwvcmVhbG1zL3J0IiwiYXVkIjoibmlkaWdyYXRpcy1ycyIsInN1YiI6IjhmZjI0OTZkLTkyYzctNDQxMS04ZjI5LTk1NTA5MTVlN2EzMCIsInR5cCI6IkJlYXJlciIsImF6cCI6InJfdG9zY2FuX19uaWRpZ3JhdGlzIiwic2Vzc2lvbl9zdGF0ZSI6Ijg3OWRmMDVjLWIwNDktNDliYy04MDgyLWY3NTllZGJjODRjYyIsImFjciI6IjEiLCJzY29wZSI6Im5pZGlncmF0aXMtcnMvYXVkaWVuY2UgZGVmYXVsdCBwcm9maWxlIiwic2lkIjoiODc5ZGYwNWMtYjA0OS00OWJjLTgwODItZjc1OWVkYmM4NGNjIiwiYXV0aF90eXBlIjoic3BpZC1kZW1vLWlkcCIsImF1dGhfbGV2ZWwiOiIyIiwicHJlZmVycmVkX3VzZXJuYW1lIjoidGluaXQtcGxvbXJjMDFwMzBsNzM2eSJ9.OIdO1u--lzqaAa1fPDzCa1VkJ_hBe9Q1yFlFe6opDeKqS4T45QasT9ei-0Hy_AFYmoOq9wwdMVt9T8P9jEvMMKtubcM4AgsV13fPLsfCL-nvvgyaBATIiIu1NBDuA12_NEWchLuE16X4bChtGhljCSyaC_VI4QnWWyu41QHVZThWmj9KNh-8G4SzFtiN7lNAfW-m_ARXynMcHM5d1_Etr8roOEoDUBd3gNphEu61qvqd5iFhzzMXZs0EL1TXp7Ay4kWM_DeetPIBYUwwOB7zRHvOydZUpIH37xOjNhmXr9KGBnkSFuWVbSs_gbTJBGHcKLtSORHgmCQwDYFUFRYGmQ';
      default:
        return 'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJDbjE2ODZIenkzdUpxWGtHcUF6c1hhS0dGRTFsRHhDcFRsOTB3UklFc1FFIn0.eyJleHAiOjE2OTQ2OTQzNTIsImlhdCI6MTY5NDY5NDA1MiwiYXV0aF90aW1lIjoxNjk0Njk0MDUyLCJqdGkiOiIxOTFkMDFjNS00NDRmLTRmMDktODA4OS1iZTZiMzE0NWZiOTMiLCJpc3MiOiJodHRwczovL3RyaWFsLmF1dGgucmVnaW9uZS50b3NjYW5hLml0L2F1dGgtdHJpYWwvcmVhbG1zL3J0IiwiYXVkIjoibmlkaWdyYXRpcy1ycyIsInN1YiI6ImQyN2EwYWExLWFmNzAtNDQ5ZS1iMjQ0LTU4NjA0YzNhYzJhNSIsInR5cCI6IkJlYXJlciIsImF6cCI6InJfdG9zY2FuX19uaWRpZ3JhdGlzIiwic2Vzc2lvbl9zdGF0ZSI6ImNhZTg5MmNiLWE4OWUtNGJlOC1iMmU5LTkxMDU0YTFjZjVhMCIsImFjciI6IjEiLCJzY29wZSI6ImVtYWlsIG5pZGlncmF0aXMtcnMvYXVkaWVuY2UgZGVmYXVsdCBwcm9maWxlIiwic2lkIjoiY2FlODkyY2ItYTg5ZS00YmU4LWIyZTktOTEwNTRhMWNmNWEwIiwiYXV0aF90eXBlIjoic3BpZC1kZW1vLWlkcCIsImF1dGhfbGV2ZWwiOiIyIiwicHJlZmVycmVkX3VzZXJuYW1lIjoidGluaXQtZHJjZ25uMTJhNDZhMzI2ayJ9.jKru4VUgWa9kNWvRPDcyktmBRRX3PlMA6N7-YxMtVMumvqdKJYbmY_d73SuNOaQ5HZSUURFXzqpA4wmZZsFgtP5bouMrH3SthuVrwutSfGLMYiQ2rN0sLrp1aBjX4DV7FCK7nZISJ_WkIDbQZm-l7v-k-Hs6x8WiJ6rSLh2ReEdAojS1FgeNoxqJmOywt5GqZcVogC-SRk7iu8mE8yO9dzbSLMFHDDazsD4LiTc8uGJNqgQWtH1Z-KAhZVNlgHW_jTGOZFTpOofXXq5VsysEtQPDU5c1odsLJBtBu-CrveE3ina0HQmPa5YEMVu7bd-QT6UfOJ-snNrnC4wyPl7bMQ';
    }
  }

  export const devGetUserInfoByUserType = (userType) => {
    switch (userType) {
      case 'ente':
        return {
                'sub': '215c456e-43fc-49f3-ae38-9dfcdbd5f0cf',
                'auth_type': 'spid-demo-idp',
                'birthdate': '1999-05-05',
                'gender': 'M',
                'auth_level': '2',
                'name': 'Alessandro Manzoni',
                'extras': {
                  'placeOfBirth': 'F205',
                  'idCard': 'passaporto TT232323 questuraMilano 2017-10-01 2027-10-01',
                  'familyName': 'Manzoni',
                  'name': 'Alessandro',
                  'spidCode': 'SPID-011',
                  'dateOfBirth': '1999-05-05',
                  'countyOfBirth': 'MI',
                  'fiscalNumber': 'TINIT-MNZLSN99E05F205J',
                  'expirationDate': '2019-09-01'
                },
                'spidCode': 'SPID-011',
                'preferred_username': 'tinit-mnzlsn99e05f205j',
                'given_name': 'Alessandro',
                'family_name': 'Manzoni'
              };
      case 'regione':
        return {
                  'sub': 'dcfcc1af-3d07-48d8-9dd2-a3e13239c0d3',
                  'auth_type': 'spid-demo-idp',
                  'birthdate': '1976-08-06',
                  'gender': 'M',
                  'auth_level': '2',
                  'extras': {
                    'placeOfBirth': 'B715',
                    'idCard': 'patente Z1Z111111Z motorizzazioneBarletta 2017-03-09 2027-08-06',
                    'familyName': 'Fieramosca',
                    'name': 'Ettore',
                    'spidCode': 'SPID-007',
                    'dateOfBirth': '1976-08-06',
                    'countyOfBirth': 'CE',
                    'fiscalNumber': 'TINIT-FRMTTR76M06B715E',
                    'expirationDate': '2019-08-01'
                  },
                  'spidCode': 'SPID-007',
                  'preferred_username': 'tinit-frmttr76m06b715e',
                  'given_name': 'Ettore',
                  'digitalAddress': '',
                  'name': 'Ettore Fieramosca',
                  'family_name': 'Fieramosca',
                  'email': 'trediciitalianicontrotredicifrancesi@hotmail.com'
                }
      case 'admin':
        return {
                'sub': '8ff2496d-92c7-4411-8f29-9550915e7a30',
                'auth_type': 'spid-demo-idp',
                'birthdate': '2001-09-30',
                'gender': 'M',
                'auth_level': '2',
                'name': 'Marco Polo',
                'extras': {
                  'placeOfBirth': 'L736',
                  'idCard': 'cartaIdentita AZ765432 comuneVenezia 2015-03-12 2025-09-30',
                  'familyName': 'Polo',
                  'name': 'Marco',
                  'spidCode': 'SPID-009',
                  'dateOfBirth': '2001-09-30',
                  'countyOfBirth': 'VE',
                  'fiscalNumber': 'TINIT-PLOMRC01P30L736Y',
                  'expirationDate': '2019-10-01'
                },
                'spidCode': 'SPID-009',
                'preferred_username': 'tinit-plomrc01p30l736y',
                'given_name': 'Marco',
                'family_name': 'Polo'
              };
      default:
        return {
                'sub': 'd27a0aa1-af70-449e-b244-58604c3ac2a5',
                'auth_type': 'spid-demo-idp',
                'birthdate': '1912-01-06',
                'gender': 'F',
                'auth_level': '2',
                'extras': {
                  'placeOfBirth': 'A326',
                  'idCard': 'cartaIdentita AA121212 comuneAosta 2010-01-13 2020-01-06',
                  'familyName': 'D\'Arco',
                  'name': 'Giovanna',
                  'spidCode': 'SPID-006',
                  'dateOfBirth': '1912-01-06',
                  'countyOfBirth': 'AO',
                  'fiscalNumber': 'TINIT-MNZLSN99E05F205J',
                  'expirationDate': '2019-06-04'
                },
                'spidCode': 'SPID-006',
                'preferred_username': 'tinit-MNZLSN99E05F205J',
                'given_name': 'Giovanna',
                'digitalAddress': '',
                'name': 'Giovanna D\'Arco',
                'family_name': 'D\'Arco',
                'email': 'lapulzelladorléans@yahoo.fr'
              };
    }
  }